import { ref } from 'vue';
import { ChainExchangeRatesModel } from '../../../common';

// Local
const defaultPageSize = ref<number>(25);

// Exchange rates
const exchangeRates = ref<ChainExchangeRatesModel>(null);
const exchangeRatesAvailable = ref(false);

// Breeding global variables
const breedingPlatformFee = ref<string>(null);
const breedingTransactionCost = ref<string>(null);
const breedingTransactionCostCurrency = ref<string>(null);
const breedingSeasonActive = ref<boolean>(true);
const breedingCurrency = ref<string>(null);
const externalBreedingFeeCurrency = ref<string>(null);
const breedingCooldownCurrency = ref<string>(null);
const breedingCooldown = ref<number>(null);
const breedingCooldownTimeUnit = ref<number>(null);
const refillBreedingCooldownCost = ref<number>(null);

// Stamina global variables
const staminaRefillCurrency = ref<string>(null);
const staminaRefill1x = ref<number>(null);
const staminaPerTimeUnit = ref<number>(null);
const staminaCap = ref<number>(null);

export {
  breedingPlatformFee,
  breedingTransactionCost,
  breedingTransactionCostCurrency,
  breedingSeasonActive,
  breedingCurrency,
  defaultPageSize,
  exchangeRates,
  exchangeRatesAvailable,
  externalBreedingFeeCurrency,
  breedingCooldownCurrency,
  breedingCooldown,
  breedingCooldownTimeUnit,
  refillBreedingCooldownCost,
  staminaRefillCurrency,
  staminaRefill1x,
  staminaPerTimeUnit,
  staminaCap
};
